<template>
  <generic-modal
    :title="$t('sirc credit information case details')"
    size="fullscreen"
    ref="generic_modal"
  >
    <div>
      <div class="container py-5" v-if="meta && meta.sirc_data">
        <div class="box">
          <h1 class="title is-3 mb-2">
            {{ meta.name }}
            <span class="tag is-info is-light ml-2">{{ meta.dpi }}</span>
            <span class="tag is-warning is-light ml-2">{{ meta.nit }}</span>
          </h1>
          <p class="subtitle is-6 mb-4">
            <b>{{ $t("promissory note number") }}:</b>
            {{ meta.promissory_note_number }}
          </p>
          <div class="columns is-multiline">
            <div class="column is-4">
              <div class="notification is-primary is-light">
                <b>Deuda Directa Total:</b>
                <br />
                Q{{ number(meta.sirc_data.infgral.totDeudaDir) }}
              </div>
            </div>
            <div class="column is-4">
              <div class="notification is-link is-light">
                <b>Deuda Contingente Total:</b>
                <br />
                Q{{ number(meta.sirc_data.infgral.totDeudaConting) }}
              </div>
            </div>
            <div class="column is-4">
              <div class="notification is-info is-light">
                <b>Deuda Indirecta Total:</b>
                <br />
                Q{{ number(meta.sirc_data.infgral.totDeudaIndir) }}
              </div>
            </div>
          </div>

          <div class="box mt-4">
            <h2 class="title is-5 mb-3">Créditos Vigentes Directos</h2>
            <table class="table is-fullwidth is-striped is-hoverable">
              <thead>
                <tr>
                  <th>Entidad</th>
                  <th>Tipo</th>
                  <th>Estado</th>
                  <th>Moneda</th>
                  <th>Capital Original</th>
                  <th>Saldo</th>
                  <th>Fecha Concesión</th>
                  <th>Garantía</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(a, idx) in meta.sirc_data.endeudaDirecto.activos"
                  :key="idx"
                >
                  <td>{{ a.nomEntidad }}</td>
                  <td>{{ a.descTipoActivo }}</td>
                  <td>
                    <span class="tag is-success is-light">{{
                      a.descEstado
                    }}</span>
                  </td>
                  <td>{{ a.descMoneda }}</td>
                  <td>Q{{ number(a.capitalOrig) }}</td>
                  <td>Q{{ number(a.saldo) }}</td>
                  <td>{{ a.fecconce }}</td>
                  <td>{{ a.descTipoGara }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="box mt-4">
            <h2 class="title is-5 mb-3">Histórico de Deuda Directa</h2>
            <table
              class="table is-fullwidth is-bordered is-narrow is-hoverable"
            >
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Total Deuda</th>
                  <th>Peor Calificación</th>
                  <th>Mora Capital</th>
                  <th>Mora Intereses</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(h, idx) in meta.sirc_data.histEndeudaDirecto
                    .valuacion"
                  :key="idx"
                >
                  <td>{{ formatFecha(h.fecha) }}</td>
                  <td>Q{{ number(h.totDeuda) }}</td>
                  <td>{{ h.peorCalificacion }}</td>
                  <td>{{ h.totMoroCapital }}</td>
                  <td>{{ h.totMoroIntereses }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="content mt-5">
            <h2 class="title is-5">Resumen SIRC</h2>
            <ul>
              <li>
                <b>Créditos Vigentes Directos:</b>
                {{ meta.sirc_data.infgral.credVigentesDirectos }}
              </li>
              <li>
                <b>Créditos Cancelados Directos:</b>
                {{ meta.sirc_data.infgral.credCanceladosDirectos }}
              </li>
              <li>
                <b>Créditos Vigentes Indirectos:</b>
                {{ meta.sirc_data.infgral.credVigentesIndirectos }}
              </li>
              <li>
                <b>Créditos Cancelados Indirectos:</b>
                {{ meta.sirc_data.infgral.credCanceladosIndirectos }}
              </li>
              <li>
                <b>Referencia SIB:</b>
                {{ meta.sirc_data.infgral.referenciaSIB }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- <pre>{{ meta }}</pre> -->
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import Chart from "chart.js/auto";

export default {
  name: "FactoringModal",
  components: { GenericModal },
  data() {
    return {
      meta: {},
      error: "",
      chart: null,
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.name /* || !v.meta.sale_price */;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(uuid) {
      let v = this;
      v.set_initial_state();

      get("/sirc-credit-information/case", { uuid: uuid })
        .then((element) => {
          v.meta = element;
          v.$refs.generic_modal.show_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    save() {},
    set_initial_state() {
      let v = this;
      v.meta = {
        name: "",
        settings: {
          execute_sirc: true,
        },
      };
      v.error = "";
      // v.uuid = "";
    },
    number(val) {
      if (!val) return "0.00";
      return Number(val.replace(",", ".")).toLocaleString("es-GT", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    formatFecha(fecha) {
      // Convierte "31052025" a "31/05/2025"
      if (!fecha || fecha.length !== 8) return fecha;
      return `${fecha.slice(0, 2)}/${fecha.slice(2, 4)}/${fecha.slice(4)}`;
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style scoped>
.box {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
</style>
